import { Image2 } from "./image2";
import React from "react";

export const Gallery2 = (props) => {
  return (
    <div id="Youtube_thumbnails" className="text-center">
      <div className="container">
        <div className="section-title">
          <br></br><br></br>
          <h1>"How to" Thumbnail</h1>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title2}-${i}`}
                    className="col-sm-6 col-md-3 col-lg-4"
                  >
                    <Image2
                      title2={d.title2}
                      largeImage2={d.largeImage2}
                      smallImage2={d.smallImage2}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
    
  );
};

